import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { domainConfigsDataProvider, RESOURCE } from './dataProvider';

registerModuleDataProvider(RESOURCE, domainConfigsDataProvider);
